import api from 'src/utils/ajax';
import { camelcaseKeys } from 'src/utils/camelize-keys';

import { Location } from './_types';
import { denormalizeLocation, normalizeLocation } from './normalizers';

interface FetchLocationsParams {
  page?: number;
  per?: number;
  search?: string;
  sortDir?: string;
  sort?: string;
  fetchAll?: boolean;
}

export const fetchLocations = async (
  params?: FetchLocationsParams
): Promise<{ locations: Location[]; meta: any }> => {
  const response = await api.get('/api/v4/fbm/locations', {
    params: {
      per: params?.per,
      page: params?.page,
      fetch_all: params?.fetchAll,
      'q[name_cont]': params?.search,
      'q[s]':
        params?.sort && params?.sortDir
          ? `${params.sort} ${params.sortDir}`
          : undefined,
    },
  });
  if (response.data.location) {
    return {
      locations: response.data.location.map(normalizeLocation),
      meta: response.data.meta,
    };
  } else {
    return {
      locations: response.data.map(normalizeLocation),
      meta: response.data.length,
    };
  }
};

export const fetchLocation = async (id: Location['id']): Promise<Location> => {
  const response = await api.get(`/api/v4/fbm/locations/${id}`);
  return normalizeLocation(response.data);
};

export const updateLocation = async (location: Location): Promise<Location> => {
  const response = await api.put(`/api/v4/fbm/locations/${location.id}`, {
    location: denormalizeLocation(location),
  });
  return normalizeLocation(response.data);
};

export const createLocation = async (location: Location): Promise<Location> => {
  const response = await api.post(`/api/v4/fbm/locations/`, {
    location: denormalizeLocation(location),
  });
  return normalizeLocation(response.data);
};

export const destroyLocation = async (
  id: Location['id']
): Promise<Location> => {
  const response = await api.delete(`/api/v4/fbm/locations/${id}`);
  return normalizeLocation(response.data);
};

export const transferToLocation = async (
  locationId: Location['id'],
  amount: number,
  memo: string
) => {
  const response = await api.post(
    `/api/v4/fbm/locations/${locationId}/transfer_to`,
    {
      amount,
      memo,
    }
  );

  return camelcaseKeys(response.data);
};
